export enum RedeemCredentialType {
  RedemptionUrl = 'redemptionUrl',
  BypassUrl = 'bypassUrl',
  CardNumber = 'cardNumber',
  SecretCode = 'secretCode',
  RewardSecurityUrl = 'rewardSecurityUrl',
  RewardSecurityCode = 'rewardSecurityCode',
  Url = 'url',
  Pin = 'pin',
  Code = 'code',
  CodePin = 'codePin',
  UrlPin = 'URL + Pin',
  UrlPinTogether = 'urlPin',
  CardCode = 'cardCode',
  LandingPage = 'landingPage',
}

export interface IProduct {
  id: number;
  name: string;
  image: string;
  provider: string;
}

export interface ICredentials {
  label: string;
  value: string;
  type: string;
  credentialType: RedeemCredentialType;
}

export interface IRedeemResponse {
  product: IProduct;
  credentials: ICredentials[];
  redemption: string;
  customLogo?: string;
}
